// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3ONNi","productName":"Table_productName__2RU5Y"};